import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { AppContext } from '../ContextApi/ContextApi';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import Switch from "react-switch";
import { basePath, currentDateAndTime, formatDate } from '../Constants/constant';
import UserRegistration from '../Registration/UserRegistration/UserRegistration';
import Loader, { SmallLoader } from '../Usables/Loader';
import NoRecords from '../Usables/NoRecords';
import Swal from 'sweetalert2';
import RefreshButton from '../Usables/RefreshButton';
import PageBanner from '../Usables/PageBanner';
import { IoMdAddCircleOutline } from "react-icons/io";
import InputField from '../Usables/InputField';
import Dropdown from '../Usables/Dropdown';
import BasicButton, { DeleteButton } from '../Usables/Buttons';
import SortingTable from '../Usables/SortingTable';

function UserDetails(props) {
    const { index } = useParams();
    const { user, apiHeaderJSON } = useContext(AppContext);
    const [allUsers, setAllUsers] = useState([]);
    const [postJob, setPostJob] = useState(false);
    const [editJob, setEditJob] = useState(false);
    const [errors, setErrors] = useState({});
    const [loadingFilter, setLoadingFilter] = useState(false);
    // loading === "1" => Initial loading, 
    // loading === "2" => edit or create user loading, 
    // loading === "3" => pagination loading,
    // loading === val?.id => Change status loading,
    const [loading, setLoading] = useState(true); 
    const [formData, setFormData] = useState({});
    const [sortConfig, setSortConfig] = useState({ key: "name", direction: "asc" });
    const [pagination, setPagination] = useState({page: 1, totalRecords: "", totalPages: "", limit: 10,});
    const [ischanged, setIschanged] = useState({getListChanged: false,});
    const [filterData, setFilterData] = useState({});

    const userStatus = [
        { value: null, label: 'All' },
        { value: 1, label: 'Active' },
        { value: 2, label: 'In-active' },
    ];

    const getList = useCallback(async () => {
        try {
            const response = await axios.get(`${basePath}/getuserbyPage`, {
                params: {
                    limit: 500,
                    page: 1,
                    filter: JSON.stringify(filterData),
                },
                headers:apiHeaderJSON
            });
            setAllUsers(response?.data?.user);
            setPagination({
                ...pagination,
                totalPages: response?.data?.pages,
                totalRecords: response?.data?.totalRecords
            });
            setLoading(false);
            setLoadingFilter(false);
        } catch (error) {
            setLoadingFilter(false);
            console.log(error);
        }
    },[pagination, filterData, apiHeaderJSON]);

    useEffect(() => {
        if(ischanged?.getListChanged){
            // console.log("in getList");
            getList();
            setIschanged({ ...ischanged, getListChanged: false });
        }
    }, [ischanged?.getListChanged]);

    useEffect(() => {
        setLoading("1");
        getList();
    }, []);

    const handleExport = async () => {
        try {
            setLoadingFilter("3");
            const response = await axios.get(`${basePath}/getuserbyPage`, {
                responseType: 'blob', // Ensure response is treated as a blob
                params: {
                    download:'yes',
                    filter: JSON.stringify(filterData),
                },
                headers:apiHeaderJSON
            });

            // Create a URL for the blob object
            const url = window.URL.createObjectURL(new Blob([response.data]));

            // Create a temporary <a> element to trigger the download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `User Details ${formatDate(currentDateAndTime())}.xlsx`);
            document.body.appendChild(link);
            link.click();

            // Clean up resources
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
            setLoadingFilter(false);
        } catch (error) {
            console.error('Error exporting jobs:', error);
            setLoadingFilter(false);
        }
    };

    const handleSubmitForm = (e) => {
        e.preventDefault();
        if(formData?.id){
            handleSubmitEditForm(e);
        }
        else{
            handleSubmit(e);
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        const errorList = validateForm();
        console.log("errorList", errorList);
        if (Object.keys(errorList).length > 0) {
            setErrors(errorList);
            return;
        } 
        const data = {
            name: `${formData?.firstName.trim()} ${formData?.lastName.trim()}`,
            designation: formData?.designation.trim(),
            email: formData?.email.trim(),
            phone: formData?.phone.trim(),
            role_id: formData?.role_id,
            company_id: formData?.company_id,
            username_login: formData?.username_login.trim(),
            password_login: formData?.password_login.trim(),
        }
        setLoading("2");
        const options = {
            headers: apiHeaderJSON,
            data: data,
        }
        axios.post(`${basePath}/user`, { data }, options )
            .then((response) => {
                if (response.status === 200) {                    
                    setLoading(false);
                    handleClose();
                    getList();
                    toast.success(response?.message || "User Registered Successfully");
                }
                else {
                    setLoading(false);
                    toast.error(response?.message || "Unable to register");
                }
            })
            .catch((e) => {
                setLoading(false);
                console.log(e);
                toast.error(e?.response?.message || "Unable to register");
            });
    }
    const validateForm = ()=>{
        const errors = {};

        if (!formData?.firstName || formData?.firstName.trim() === "") {
            errors.firstName = "First name is required";
            return errors;
        } else if (formData?.firstName.length < 3) {
            errors.firstName = "First name must be at least 3 characters";
            return errors;
        } else if (!/^[A-Za-z\s]+$/.test(formData?.firstName)) {
            errors.firstName = "First name can only contain letters";
            return errors;
        }
        
        if (!formData?.lastName || formData?.lastName.trim() === "") {
            errors.lastName = "Last name is required";
            return errors;
        } else if (formData?.lastName.length < 3) {
            errors.lastName = "Last name must be at least 3 characters";
            return errors;
        } else if (!/^[A-Za-z\s]+$/.test(formData?.lastName)) {
            errors.lastName = "Last name can only contain letters";
            return errors;
        }
        
        if (!formData?.email || formData?.email.trim() === "") {
            errors.email = "Email is required";
            return errors;
        } else if (
            !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData?.email)
        ) {
            errors.email = "Invalid email address";
            return errors;
        }

        if (!formData?.phone || formData?.phone.trim() === "") {
            errors.phone = "Mobile number is required";
        } else if (!/^[6-9]\d{9}$/.test(formData?.phone)) {
            errors.phone = "Mobile number must be a valid 10-digit Indian number";
        }

        if (!formData?.designation || formData?.designation.trim() === "") {
            errors.designation = "Designation is required";
            return errors;
        } else if (formData?.designation.length < 2) {
            errors.designation = "Designation must be at least 2 characters";
            return errors;
        } else if (!/^[A-Za-z\s]+$/.test(formData?.designation)) {
            errors.designation = "Designation can only contain letters";
            return errors;
        }

        if(!formData?.role_id){
            errors.role_id = "Role selection is required";
            return errors;
        }
        if(formData?.role_id === 13 && !formData?.company_id){
            errors.company_id = "Company selection is required";
            return errors;
        }

        if (!formData?.username_login || formData?.username_login.trim() === "") {
            errors.username_login = "Last name is required";
            return errors;
        } else if (formData?.username_login.length < 3) {
            errors.username_login = "Last name must be at least 3 characters";
            return errors;
        } else if (!/^[A-Za-z\s]+$/.test(formData?.username_login)) {
            errors.username_login = "Last name can only contain letters";
            return errors;
        }

        if (formData?.role_id === 13 && !formData?.password_login && formData?.password_login.trim() === ""){
            errors.password_login = "Password is required";
            return errors;
        } else if (formData?.password_login?.length < 3) {
            errors.password_login = "Password must be at least 3 characters";
            return errors;
        }

        return errors;
    }
    const handleUserStatus = async (row) => {
        Swal.fire({
            title: 'Are you sure?',
            text: `You want to change status to ${row?.activated === 1 ? "Inactive" : "Activate"}!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Change!',
            cancelButtonText: 'No, Cancel!',
            confirmButtonColor: '#1F1E30',
            cancelButtonColor: '#F44336',
            allowOutsideClick: false,
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const data = {
                        requested_user_id: row?.id,
                        activated: row?.activated === 1 ? 2 : 1,
                    };
                    setLoading(row?.id);

                    const options = {
                        headers: { ...apiHeaderJSON },
                    };

                    const response = await axios.patch(`${basePath}/handleUserStatus`, data, options);
                    // console.log(`User action response ==>`, response);

                    if (response.status === 200) {
                        toast.success(response?.data?.message || "User status updated successfully");
                        getList();
                    } else {
                        toast.error(response?.data?.message || "Unable to update");
                    }

                    setLoading(false);
                } catch (error) {
                    setLoading(false);
                    console.log("error :", error);
                    toast.error(error?.response?.data?.message || "Unable to update");
                }
            }
        });
    };

    const handleSubmitEditForm = (e) => {
        e.preventDefault();
        const data = {
            name: `${formData?.firstName.trim()} ${formData?.lastName.trim()}`,
            designation: formData?.designation,
            email: formData?.email,
            phone: formData?.phone,
            role_id: formData?.role_id,
            username_login: formData?.username_login,
            password_login: formData?.password_login
        };

        if (formData?.email) {
            setLoading(true);
            const options = {
                url: `${basePath}/updateuser/${formData?.id}`,
                method: "PUT",
                headers: {
                   ...apiHeaderJSON
                },
                data: data,
            }
            axios(options)
                .then((response) => {
                    if (response.status === 200) {
                        getList();
                        handleClose();
                        toast.success(response?.data?.message || "User Data Updated Successfully");
                        setFormData({});
                    }
                    else {
                        toast.error(response?.data?.message || "Unable To Update");
                    }
                    setLoading(false);
                })
                .catch((e) => {
                    setLoading(false);
                    console.log(e);
                    toast.error(e.response?.data?.message || "Unable To Update");
                });
        }
        else {
            toast.error();
        }
    }

    const handleEdit = () => {
        setEditJob(true);
        
    }
    const handleCancelEdit = (idx) => {
        setFormData({
            id: postJob?.id,
            firstName: postJob?.name?.split(" ")[0],
            lastName: postJob?.name?.split(" ")[1],
            designation: postJob?.designation,
            email: postJob?.email,
            phone: postJob?.phone,
            role_id: postJob?.role_id,
            company_id: postJob?.company_id,
            username_login: postJob?.username_login,
            password_login: postJob?.password_login
        });
        setEditJob(false);
        
    }

    const handleView = (val)=> {
        setFormData({
            id: val?.id,
            firstName: val?.name.split(" ")[0],
            lastName: val?.name.split(" ")[1],
            designation: val?.designation,
            email: val?.email,
            phone: val?.phone,
            role_id: val?.role_id,
            company_id: val?.company_id,
            username_login: val?.username_login,
            password_login: val?.password_login
        });
        setPostJob(val);
    }

    const handleDelete = (e) => {
        const {value} = e.target;
        Swal.fire({
            title: 'Are you sure?',
            text: `You want to delete? You won't be able to revert this.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Cancel!',
            confirmButtonColor: '#1F1E30', 
            cancelButtonColor: '#F44336',
            allowOutsideClick:false,
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        title: 'Please wait...',
                        html: 'Deleting...',
                        allowOutsideClick: false,
                        didOpen: () => {Swal.showLoading();}
                    });
                    setLoading("2");
                    const options = {
                        headers: {...apiHeaderJSON},
                    }
                    axios.delete(`${basePath}/deleteuser/${value?.id}`,options)
                    .then((response) => {
                        // console.log(`delete user response ==>`, response);
                        if (response.status === 200) {
                            getList();
                            toast.success( response?.data?.message || "User Deleted Successfully");
                        }
                        else {
                            toast.error(response?.data?.message || "Unable to delete user.");
                        }
                        setLoading(false);
                        Swal.close();
                    })
                    .catch((error) => {
                        setLoading(false);
                        Swal.close();
                        toast.error(error?.response?.data?.message || "Unable to delete user.");
                    });
                }
            }
        )
    }
    const handleRefresh = () => {
        if (!loading || !loadingFilter) {
            setLoading("1");
            getList();
        }
    }

    const handleClose = ()=> {
        setPostJob(false); 
        setFormData({});
        setFilterData({});
        setEditJob(false);
    }
    const handleChange = useCallback((event)=> {
        const {name, value} = event?.target;
        // console.log("name, value", name, value);
        setFormData({ ...formData, [name]: value, });
        setErrors({ ...errors, [name]: "", });
        // it will call getList after defined time (delay)
        // debounceList();
    },[formData,errors]);

    const handleFilter = useCallback(()=>{ 
        setLoadingFilter("1"); 
        getList();
    },[getList]);

    const handleClear = useCallback(()=>{ 
        setLoadingFilter("2"); 
        setFilterData({ name: "", designation: "", activated: null});
        setIschanged({...ischanged, getListChanged: true});
    },[ischanged]);

    const handleChangeFilter = useCallback((event)=> {
        const {name, value} = event?.target;
        // console.log("name, value", name, value);
        setFilterData({ ...filterData, [name]: value, });
        // it will call getList after defined time (delay)
        // debounceList();
    },[filterData]);

    const handleLimit = useCallback((e)=> {
        setPagination({...pagination, limit: e.target.value});
        setIschanged({...ischanged, getListChanged: true});
    },[pagination, ischanged]);

    const handlePrev = useCallback((e)=> {
        if (pagination?.page > 1) {
            setPagination({...pagination, page: pagination?.page - 1});
            setIschanged({...ischanged, getListChanged: true});
        }
    },[pagination, ischanged]);

    const handleNext = useCallback((e)=> {
        if (pagination?.totalPages > pagination?.page) {
            setPagination({...pagination, page: pagination?.page + 1});
            setIschanged({...ischanged, getListChanged: true});
        }
    },[pagination, ischanged]);

    const sortedData = useMemo(() => {
        const sortableData = [...allUsers];

        if (sortConfig.key && sortConfig.direction) {
            sortableData.sort((a, b) => {
                const aVal = a[sortConfig.key] ?? "";
                const bVal = b[sortConfig.key] ?? "";
                if (typeof aVal === "string" && typeof bVal === "string") {
                    return sortConfig.direction === "asc"
                    ? aVal.localeCompare(bVal)
                    : bVal.localeCompare(aVal);
                }

                // fallback for numbers/dates
                if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
                if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
                return 0;
                }); 
            }
            return sortableData;
        }, [allUsers, sortConfig]);

    const requestSort = (key) => {
        let direction = "asc";

        if (sortConfig.key === key && sortConfig.direction === "asc") {
            direction = "desc";
        } else if (sortConfig.key === key && sortConfig.direction === "desc") {
            direction = "asc";
            key = "name";
        }

        setSortConfig({ key, direction });
    };

    return (
        <section className='lightBabyGreen customScroll mb-5'>
            {/* RefreshButton => used for refresh table data */}
            <RefreshButton onClick={handleRefresh} position='fixed' />
            <div>
                {/* PageBanner => used to show page banner info */}
                <PageBanner pageName='User Details' pageTitle='Ready to start your day' src='/img/registration.png' alt="all jobs" />
                {postJob && (
                    <UserRegistration
                    data={formData} 
                    onEdit={handleEdit}
                    onCancel={handleCancelEdit}
                    onClose={handleClose}
                    OnlyView={!user[index]?.edit_access}
                    disabled={!editJob}
                    onSubmit={handleSubmitForm}
                    onChange={handleChange}
                    loading={loading === "2"}
                    errors={errors}
                    />
                )}
                {/* Filter */}
                <div className=' grid lg:grid-cols-6 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 items-center gap-3 grayBlurShadow bg-white p-3 mt-5 mb-3 rounded-xl'>
                    {
                        user[index]?.add_access ?
                            <div onClick={(e) => { setPostJob(true); setEditJob(true); }} className='darkPurple w-fit my-2 ml-2 cursor-pointer rounded-full py-2 px-3 text-white flex items-center gap-2 font-bold grayBlurShadow hoverGreen navAnimation'>
                                <IoMdAddCircleOutline className=' text-4xl text-white' />
                                <button>Add New User</button>
                            </div> : null
                    }
                    <InputField  id="name" name="name" type="text" label="Name:"
                    placeholder="Enter Name"
                    disabled={loading === '3'}
                    value={filterData?.name}
                    onChange={handleChangeFilter}
                    />
                    <InputField  id="designation" name="designation" type="text" label="Designation:"
                    placeholder="Enter Designation"
                    disabled={loading === '3'}
                    value={filterData?.designation}
                    onChange={handleChangeFilter}
                    />
                    <Dropdown id="activated" name="activated" label="User Status:"
                    placeholder={`All`}
                    disabled={loading === '3'}
                    value={filterData?.activated}
                    options={userStatus}
                    onChange={handleChangeFilter}
                    />
                    <div className="flex gap-3 col-span-1">
                        <div className=" flex flex-col">
                            <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Apply Filter</label>
                            <BasicButton onClick={handleFilter} buttonName='Apply Filter' className='darkPurple text-nowrap' shadow={true}
                            disabled={loading || loadingFilter || (!filterData?.name && !filterData?.designation && !filterData?.activated)} 
                            loading={loadingFilter === "1"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hoverGreen" />
                        </div>
                        <div className=" flex flex-col">
                            <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Clear Filter</label>
                            <BasicButton onClick={handleClear} buttonName='Clear Filter' className="bg-red-600 text-nowrap" shadow={true}
                            disabled={loading || loadingFilter || (!filterData?.name && !filterData?.designation && !filterData?.activated)} 
                            loading={loadingFilter === "2"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-red-900" />
                        </div>
                        <div className=" flex flex-col">
                            <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Excel Export</label>
                            <BasicButton onClick={handleExport} buttonName='Excel' className="bg-green-800 text-nowrap" shadow={true}
                            disabled={loading || loadingFilter || allUsers?.length === 0} 
                            loading={loadingFilter === "3"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-green-950" />
                        </div>
                    </div>
                </div>
                {loading === "1" ?
                    <Loader height="h-[48dvh]" /> :
                    Array.isArray(allUsers) && allUsers?.length > 0 ?
                        <section  className='tableWrapper pb-5'>
                            <div className='tableBody'>
                                <table className='w-full table-fixed border-collapse'>
                                    <thead className='tableHead'>
                                        <tr className=' text-left'>
                                            <th className=' text-center w-[5%]'>Sr.No.</th>
                                            <th className="text-center cursor-pointer" onClick={() => requestSort("created_at")}>
                                                <div className='flex items-center justify-center gap-1'>
                                                    Created Date {<SortingTable sortConfig={sortConfig} tHead="created_at" />}
                                                </div>
                                            </th>
                                            <th className="text-center cursor-pointer" onClick={() => requestSort("name")}>
                                                <div className='flex items-center gap-1'>
                                                    Name {<SortingTable sortConfig={sortConfig} tHead="name" />}
                                                </div>
                                            </th>
                                            <th className="text-center cursor-pointer" onClick={() => requestSort("designation")}>
                                                <div className='flex items-center gap-1'>
                                                    Designation {<SortingTable sortConfig={sortConfig} tHead="designation" />}
                                                </div>
                                            </th>
                                            <th className="text-center cursor-pointer" onClick={() => requestSort("email")}>
                                                <div className='flex items-center gap-1'>
                                                    Email {<SortingTable sortConfig={sortConfig} tHead="email" />}
                                                </div>
                                            </th>
                                            <th className="text-center w-[12%] cursor-pointer" onClick={() => requestSort("phone")}>
                                                <div className='flex items-center gap-1'>
                                                    Phone {<SortingTable sortConfig={sortConfig} tHead="phone" />}
                                                </div>
                                            </th>
                                            {(user[index]?.view_access || user[index]?.edit_access) && 
                                            (
                                            <th className="text-center w-[8%] cursor-pointer" onClick={() => requestSort("activated")}>
                                                <div className='flex items-center gap-1'>
                                                    Status {<SortingTable sortConfig={sortConfig} tHead="activated" />}
                                                </div>
                                            </th>
                                            )}
                                            {user[index]?.delete_access &&
                                                <th className=' text-center w-[8%]' >Actions</th>}
                                        </tr>
                                    </thead>
                                    <tbody className='tableBody '>
                                        {
                                            Array.isArray(sortedData) && sortedData?.map((val, idx) => {
                                                return (
                                                    <tr key={val?.id} id={val?.id} className=' backWhite font-semibold text-sm text-left'>
                                                        <td className=' text-center'>{idx+1}</td>
                                                        <td className=' text-center text-nowrap'>{val?.created_at ? formatDate(val?.created_at) : ""}</td>
                                                        <td>
                                                            <span className={`line-clamp-1 text-ellipsis ${val?.name && (user[index]?.view_access || user[index]?.edit_access) && "text-blue-900 hover:text-blue-700 hover:underline transition-all duration-150 ease-in-out cursor-pointer"}`} onClick={()=> {if (user[index]?.view_access || user[index]?.edit_access) handleView(val); }} >{val?.name}</span>
                                                        </td>
                                                        <td>
                                                            <span className=' whitespace-nowrap line-clamp-1 text-ellipsis'>{val?.designation}</span>
                                                        </td>
                                                        <td>
                                                            <span className=' whitespace-nowrap line-clamp-1 text-ellipsis'>{val?.email}</span>
                                                        </td>
                                                        <td>
                                                            <span className=' whitespace-nowrap line-clamp-1 text-ellipsis'>{val?.phone}</span>
                                                        </td>
                                                        {(user[index]?.view_access || user[index]?.edit_access) && (
                                                            <td className=' text-center' >
                                                                {loading === val?.id ?
                                                                <SmallLoader /> :
                                                                <Switch onChange={() => { handleUserStatus(val) }}
                                                                checked={val?.activated === 1} disabled={!user[index]?.edit_access} />
                                                                }
                                                            </td>                                                  
                                                        )}
                                                        {/* <ActionMenu id={val?.id}
                                                            permissions={{
                                                                view: user[index]?.view_access,
                                                                edit: user[index]?.edit_access,
                                                                delete: user[index]?.delete_access,
                                                            }}
                                                            onView={() => { setPostJob("1"); handleEdit(idx); }}
                                                            onEdit={() => { setPostJob("2"); handleEdit(idx); }}
                                                            onDelete={(e,id) => handleDelete(e, id)}
                                                        /> */}
                                                        {user[index]?.delete_access && <td className=' flex justify-center items-center'>
                                                            <DeleteButton data={val} onClick={handleDelete} tooltipName="Delete" disabled={loading === "2"} />
                                                        </td>}                                                        
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                            {/* <Pagination disabled={loading === "3"} onLimitChange={handleLimit} onPrevChange={handlePrev} onNextChange={handleNext}
                            limit={pagination?.limit} totalRecords={pagination?.totalRecords} allPages={pagination?.totalPages} page={pagination?.page}
                            disabledPrev={pagination?.page === 1} disabledNext={pagination?.page === pagination?.totalPages}
                            /> */}
                        </section> :
                    <NoRecords />
                }

            </div>
        </section>
    );
}

export default UserDetails;